module.exports = __webpack_public_path__ + "static/episode-1-502089b08c9c169478f7c124117a4d3a.png";